// extracted by mini-css-extract-plugin
module.exports = {"root":"LookBoardPreviewModal_root__2B4rw","closeBtn":"LookBoardPreviewModal_closeBtn__Ro0_Q"};